export class SamplingSimulationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subset",
            "baseName": "subset",
            "type": "SamplingSimulationSubset",
            "format": ""
        },
        {
            "name": "requestedRate",
            "baseName": "requestedRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "realizedKeepRate",
            "baseName": "realizedKeepRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "fittedBase",
            "baseName": "fittedBase",
            "type": "number",
            "format": "double"
        },
        {
            "name": "projectedTotalRows",
            "baseName": "projectedTotalRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "projectedKeptRows",
            "baseName": "projectedKeptRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "projectedDroppedRows",
            "baseName": "projectedDroppedRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageReduction",
            "baseName": "storageReduction",
            "type": "number",
            "format": "double"
        },
        {
            "name": "distinctSegments",
            "baseName": "distinctSegments",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "trackedSegments",
            "baseName": "trackedSegments",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "flooredSegments",
            "baseName": "flooredSegments",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "untrackedSegments",
            "baseName": "untrackedSegments",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "untrackedSubjectRows",
            "baseName": "untrackedSubjectRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "droppedAsNoiseRows",
            "baseName": "droppedAsNoiseRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "smallestTrackedCount",
            "baseName": "smallestTrackedCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "errorP50",
            "baseName": "errorP50",
            "type": "number",
            "format": "double"
        },
        {
            "name": "errorP95",
            "baseName": "errorP95",
            "type": "number",
            "format": "double"
        },
        {
            "name": "errorMax",
            "baseName": "errorMax",
            "type": "number",
            "format": "double"
        },
        {
            "name": "topSegments",
            "baseName": "topSegments",
            "type": "Array<SamplingSimulationSegment>",
            "format": ""
        },
        {
            "name": "warnings",
            "baseName": "warnings",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SamplingSimulationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
